// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IAJk","option":"styles_option__1I17t","selected":"styles_selected__1A8bQ"};